import { useEffect, useState } from 'react'

import * as Analytics from '~/lib/analytics'

const IP_API_URLS = ['https://ipapi.co/json/', 'https://api.ipify.org/?format=json']

const fetchIp = async (apiUrl: string) => {
  try {
    Analytics.addBreadcrumb(Analytics.BreadcrumbsTypes.FETCH_USER_IP_ATTEMPTED, {}, { apiUrl })

    const geoLocationResponse = await fetch(apiUrl, {
      method: 'GET',
    })

    const { ip } = await geoLocationResponse.json()

    return ip
  } catch (e) {
    Analytics.trackException(e)

    return undefined
  }
}

export const useUserIp = () => {
  const [ip, setIp] = useState('')

  useEffect(() => {
    const fetchUserIp = async () => {
      let ip = await fetchIp(IP_API_URLS[0])

      if (!ip) {
        ip = await fetchIp(IP_API_URLS[1])
      }

      setIp(ip)
    }

    fetchUserIp()
  }, [])

  return ip
}
